module.exports = __webpack_public_path__ + "img/person-cropped.jpg?b20b3adc51994d370e808729125979e3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/social/person-cropped.jpg
// module id = 306
// module chunks = 0